import { defineStore } from 'pinia'

export enum SpSearchParent {
  IGNORED,
  SEARCH_CONDITION,
  FLOATING_BUTTON
}

export const useABTestIssue395Store = defineStore('ab_test_issue_395', () => {
  const spSearchParent = ref(SpSearchParent.IGNORED)

  return {
    spSearchParent
  }
})
